/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import { RouterClient } from "../../../clients/routerClient";
import { Logger } from "../../../clients/logger";
import { BootTaskCallbackInterface } from "../types";

/**
 * Boot task that waits until system is authenticated. This task essentially is what
 * pauses Finsemble until the client has authenticated. It relies on the AuthenticationService
 * to publish (anything) on the "Authorization" channel to release the system.
 *
 * @private
 */
export class WaitForAuthenticatedTask {
	public start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.debug("waitForAuthenticatedTask start");

		const authorizationSubscriber = RouterClient.subscribe("Authorization", (err) => {
			if (!err) {
				RouterClient.unsubscribe(authorizationSubscriber);
				doneCallback("waitForAuthenticatedTask", "bootTasks", "completed");
			}
		});
	}
}
